import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Protected = ({ children }) => {
    const navigate = useNavigate();
    const Auth = localStorage.getItem('access_token');

    useEffect(() => {
        if (Auth) {
        
            navigate('/chat');
        }
    }, [Auth, navigate]);
    return <>{children}</>; 
};

export default Protected;
